<!--信号强度热力图-->
<template>
<div style="width: 100%; height: 100%;">
  <div style="position: absolute;z-index: 900;">
    <Button v-if="showchange" type="primary" size="small" style="margin-right: 3px;" @click="change">显示GPS信号</Button>
    <Button v-if="!showchange" type="primary" size="small" style="margin-right: 3px;" @click="change">显示通信信号</Button>
  </div>
  <div id="map" style="width: 100%; height: 100%;"></div>
</div>
</template>

<script>
import Vue from 'vue'
import store from '../../store'
import { GPS } from '@/libs/positonUtils'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
export default {
  name: 'wireless',
  data () {
    return {
      showchange: true,

      datalist: [],
      GPSdatalist: [],

      heatmapOverlay: true
    }
  },
  methods: {
    /**
           * 切换通信强度/GPS强度
           */
    change () {
      if (this.showchange) {
        this.showchange = false
        this._map.clearOverlays()
        // this.initElements(this.GPSdatalist)
        this.getGPSLessThanTEN()
      } else {
        this.showchange = true
        this._map.clearOverlays()
        // this.initElements(this.datalist)
        this.getRssiLessThanTEN()
      }
    },

    /**
         * 绘制热力图
         */
    initElements (e) {
      //
      // var points =[
      //   {"lng":113.218261,"lat":23.121984,"count":50},
      //   {"lng":113.223332,"lat":23.116532,"count":51},
      //   {"lng":113.219787,"lat":23.130658,"count":15},
      //   {"lng":113.218455,"lat":23.120921,"count":40},
      //   {"lng":113.218843,"lat":23.115516,"count":100},
      //   {"lng":113.22546,"lat":23.118503,"count":6},
      //   {"lng":113.223289,"lat":23.119989,"count":18},
      //   {"lng":113.218162,"lat":23.115051,"count":80},
      //   {"lng":113.222039,"lat":23.11782,"count":11},
      //   {"lng":113.21387,"lat":23.117253,"count":7},
      //   {"lng":113.21773,"lat":23.119426,"count":42},
      //   {"lng":113.221107,"lat":23.116445,"count":4},
      //   {"lng":113.217521,"lat":23.117943,"count":27},
      //   {"lng":113.219812,"lat":23.120836,"count":23},
      //   {"lng":113.220682,"lat":23.11463,"count":60},
      //   {"lng":113.215424,"lat":23.124675,"count":8},
      //   {"lng":113.219242,"lat":23.114509,"count":15},
      //   {"lng":113.222766,"lat":23.121408,"count":25},
      //   {"lng":113.221674,"lat":23.124396,"count":21},
      //   {"lng":113.227268,"lat":23.12267,"count":1},
      //   {"lng":113.217721,"lat":23.120034,"count":51},
      //   {"lng":113.212456,"lat":23.12667,"count":7},
      //   {"lng":113.220432,"lat":23.119114,"count":11},
      //   {"lng":113.225013,"lat":23.121611,"count":35},
      //   {"lng":113.218733,"lat":23.131037,"count":22},
      //   {"lng":113.219336,"lat":23.131134,"count":4},
      //   {"lng":113.213557,"lat":23.123254,"count":5},
      //   {"lng":113.218367,"lat":23.12943,"count":3},
      //   {"lng":113.224312,"lat":23.119621,"count":100},
      //   {"lng":113.223874,"lat":23.119447,"count":87},
      //   {"lng":113.224225,"lat":23.123091,"count":32},
      //   {"lng":113.217801,"lat":23.121854,"count":44},
      //   {"lng":113.217129,"lat":23.128227,"count":21},
      //   {"lng":113.226426,"lat":23.122286,"count":80},
      //   {"lng":113.221597,"lat":23.11948,"count":32},
      //   {"lng":113.223895,"lat":23.120787,"count":26},
      //   {"lng":113.223563,"lat":23.121197,"count":17},
      //   {"lng":113.217982,"lat":23.122547,"count":17},
      //   {"lng":113.226126,"lat":23.121938,"count":25},
      //   {"lng":113.22326,"lat":23.115782,"count":100},
      //   {"lng":113.219239,"lat":23.116759,"count":39},
      //   {"lng":113.217185,"lat":23.129123,"count":11},
      //   {"lng":113.217237,"lat":23.127518,"count":9},
      //   {"lng":113.217784,"lat":23.115754,"count":47},
      //   {"lng":113.220193,"lat":23.117061,"count":52},
      //   {"lng":113.222735,"lat":23.115619,"count":100},
      //   {"lng":113.218495,"lat":23.115958,"count":46},
      //   {"lng":113.216292,"lat":23.131136,"count":9},
      //   {"lng":113.219916,"lat":23.124055,"count":8},
      //   {"lng":113.22189,"lat":23.121308,"count":11},
      //   {"lng":113.213765,"lat":23.129376,"count":3},
      //   {"lng":113.218232,"lat":23.120348,"count":50},
      //   {"lng":113.217554,"lat":23.130511,"count":15},
      //   {"lng":113.218568,"lat":23.118161,"count":23},
      //   {"lng":113.213461,"lat":23.126306,"count":3},
      //   {"lng":113.22232,"lat":23.12161,"count":13},
      //   {"lng":113.2174,"lat":23.128616,"count":6},
      //   {"lng":113.224679,"lat":23.115499,"count":21},
      //   {"lng":113.22171,"lat":23.115738,"count":29},
      //   {"lng":113.217836,"lat":23.116998,"count":99},
      //   {"lng":113.220755,"lat":23.128001,"count":10},
      //   {"lng":113.214077,"lat":23.130655,"count":14},
      //   {"lng":113.226092,"lat":23.122995,"count":16},
      //   {"lng":113.21535,"lat":23.131054,"count":15},
      //   {"lng":113.213022,"lat":23.121895,"count":13},
      //   {"lng":113.215551,"lat":23.113373,"count":17},
      //   {"lng":113.221191,"lat":23.126572,"count":1},
      //   {"lng":113.219612,"lat":23.117119,"count":9},
      //   {"lng":113.218237,"lat":23.121337,"count":54},
      //   {"lng":113.223776,"lat":23.121919,"count":26},
      //   {"lng":113.217694,"lat":23.12536,"count":17},
      //   {"lng":113.215377,"lat":23.114137,"count":19},
      //   {"lng":113.217434,"lat":23.114394,"count":43},
      //   {"lng":113.22588,"lat":23.122622,"count":27},
      //   {"lng":113.218345,"lat":23.119467,"count":8},
      //   {"lng":113.226883,"lat":23.117171,"count":3},
      //   {"lng":113.223877,"lat":23.116659,"count":34},
      //   {"lng":113.215712,"lat":23.115613,"count":14},
      //   {"lng":113.219869,"lat":23.131416,"count":12},
      //   {"lng":113.216956,"lat":23.125377,"count":11},
      //   {"lng":113.22066,"lat":23.125017,"count":38},
      //   {"lng":113.216244,"lat":23.120215,"count":91},
      //   {"lng":113.21929,"lat":23.115908,"count":54},
      //   {"lng":113.222116,"lat":23.119658,"count":21},
      //   {"lng":113.2183,"lat":23.125015,"count":15},
      //   {"lng":113.221969,"lat":23.113527,"count":3},
      //   {"lng":113.222936,"lat":23.121854,"count":24},
      //   {"lng":113.21905,"lat":23.129217,"count":12},
      //   {"lng":113.224579,"lat":23.114987,"count":57},
      //   {"lng":113.22076,"lat":23.115251,"count":70},
      //   {"lng":113.225867,"lat":23.118989,"count":8}];

      var points = e

      if (!isSupportCanvas()) {
        alert('热力图目前只支持有canvas支持的浏览器,您所使用的浏览器不能使用热力图功能~')
      }
      // 详细的参数,可以查看heatmap.js的文档 https://github.com/pa7/heatmap.js/blob/master/README.md
      // 参数说明如下:
      /* visible 热力图是否显示,默认为true
             * opacity 热力的透明度,1-100
             * radius 势力图的每个点的半径大小
             * gradient  {JSON} 热力图的渐变区间 . gradient如下所示
             *	{
                    .2:'rgb(0, 255, 255)',
                    .5:'rgb(0, 110, 255)',
                    .8:'rgb(100, 0, 255)'
                }
                其中 key 表示插值的位置, 0~1.
                    value 为颜色值.
             */
      var heatmapOverlay = new BMapLib.HeatmapOverlay({ 'radius': 5, 'opacity': 0.5 })
      this.heatmapOverlay = false
      if (this.heatmapOverlay) {
        this._map.addEventListener('zoomend', function () {
          console.log(this.getZoom())
          let that = this
          if (this.getZoom() < 12) {
            heatmapOverlay.setOptions({ 'radius': 1 })
            console.log('小于：结果')
          } else if (this.getZoom() > 12) {
            heatmapOverlay.setOptions({ 'radius': 5 })
          } else if (this.getZoom() > 14) {
            heatmapOverlay.setOptions({ 'radius': 1000 })
          } else if (this.getZoom() > 15) {
            heatmapOverlay.setOptions({ 'radius': 1000 })
          } else {
            heatmapOverlay.setOptions({ 'radius': 2 })
            console.log('中间：结果')
          }
        })
      }
      this._map.addOverlay(heatmapOverlay)
      heatmapOverlay.setDataSet({ data: points, max: 100 })
      // 是否显示热力图
      // function openHeatmap(){
      //   this.heatmapOverlay.show();
      // }
      // function closeHeatmap(){
      //   this.heatmapOverlay.hide();
      // }
      // openHeatmap();
      heatmapOverlay.show()
      // function setGradient(){
      //   /*格式如下所示:
      //    {
      //          0:'rgb(102, 255, 0)',
      //          .5:'rgb(255, 170, 0)',
      //          1:'rgb(255, 0, 0)'
      //    }*/
      //   var gradient = {
      //     0.1:'rgb(0,0,255)',
      //     0.2:'rgb(0,0,255)',
      //     0.3:'rgb(0,0,255)',
      //     0.4:'rgb(0,0,255)',
      //     0.5:'rgb(252,0,0)',
      //     0.6:'rgb(252,0,0)',
      //     0.7:'rgb(252,0,0)',
      //     0.8:'rgb(252,0,0)',
      //     0.9:'rgb(252,0,0)',
      //     1:'rgb(0,0,0)'
      //   };
      //   var colors = document.querySelectorAll("input[type='color']");
      //   colors = [].slice.call(colors,0);
      //   colors.forEach(function(ele){
      //     gradient[ele.getAttribute("data-key")] = ele.value;
      //   });
      //   let that = this
      //   that.heatmapOverlay.setOptions({"gradient":gradient});
      // }
      // setGradient();
      if (!this.showchange) {
        var gradient = {
          0.1: 'rgb(0,0,255)',
          0.2: 'rgb(0,0,255)',
          0.3: 'rgb(0,0,255)',
          0.4: 'rgb(0,0,255)',
          0.5: 'rgb(252,0,0)',
          0.6: 'rgb(252,0,0)',
          0.7: 'rgb(252,0,0)',
          0.8: 'rgb(252,0,0)',
          0.9: 'rgb(252,0,0)',
          1: 'rgb(0,0,0)'
        }
        heatmapOverlay.setOptions({ 'gradient': gradient })
      }
      // 判断浏览区是否支持canvas
      function isSupportCanvas () {
        var elem = document.createElement('canvas')
        return !!(elem.getContext && elem.getContext('2d'))
      }
    },

    /**
         * 初始化GIS元素
         */
    initGisElements () {
      this._map = new BMap.Map('map')
      var point = new BMap.Point(113.271431, 23.135336)
      // var point = new BMap.Point(116.418261, 39.921984)
      this._map.centerAndZoom(point, 13)
      this._map.enableScrollWheelZoom()

      // this.initElements(this.datalist)

      //
      // var points =[
      //   {"lng":113.218261,"lat":23.121984,"count":50},
      //   {"lng":113.223332,"lat":23.116532,"count":51},
      //   {"lng":113.219787,"lat":23.130658,"count":15},
      //   {"lng":113.218455,"lat":23.120921,"count":40},
      //   {"lng":113.218843,"lat":23.115516,"count":100},
      //   {"lng":113.22546,"lat":23.118503,"count":6},
      //   {"lng":113.223289,"lat":23.119989,"count":18},
      //   {"lng":113.218162,"lat":23.115051,"count":80},
      //   {"lng":113.222039,"lat":23.11782,"count":11},
      //   {"lng":113.21387,"lat":23.117253,"count":7},
      //   {"lng":113.21773,"lat":23.119426,"count":42},
      //   {"lng":113.221107,"lat":23.116445,"count":4},
      //   {"lng":113.217521,"lat":23.117943,"count":27},
      //   {"lng":113.219812,"lat":23.120836,"count":23},
      //   {"lng":113.220682,"lat":23.11463,"count":60},
      //   {"lng":113.215424,"lat":23.124675,"count":8},
      //   {"lng":113.219242,"lat":23.114509,"count":15},
      //   {"lng":113.222766,"lat":23.121408,"count":25},
      //   {"lng":113.221674,"lat":23.124396,"count":21},
      //   {"lng":113.227268,"lat":23.12267,"count":1},
      //   {"lng":113.217721,"lat":23.120034,"count":51},
      //   {"lng":113.212456,"lat":23.12667,"count":7},
      //   {"lng":113.220432,"lat":23.119114,"count":11},
      //   {"lng":113.225013,"lat":23.121611,"count":35},
      //   {"lng":113.218733,"lat":23.131037,"count":22},
      //   {"lng":113.219336,"lat":23.131134,"count":4},
      //   {"lng":113.213557,"lat":23.123254,"count":5},
      //   {"lng":113.218367,"lat":23.12943,"count":3},
      //   {"lng":113.224312,"lat":23.119621,"count":100},
      //   {"lng":113.223874,"lat":23.119447,"count":87},
      //   {"lng":113.224225,"lat":23.123091,"count":32},
      //   {"lng":113.217801,"lat":23.121854,"count":44},
      //   {"lng":113.217129,"lat":23.128227,"count":21},
      //   {"lng":113.226426,"lat":23.122286,"count":80},
      //   {"lng":113.221597,"lat":23.11948,"count":32},
      //   {"lng":113.223895,"lat":23.120787,"count":26},
      //   {"lng":113.223563,"lat":23.121197,"count":17},
      //   {"lng":113.217982,"lat":23.122547,"count":17},
      //   {"lng":113.226126,"lat":23.121938,"count":25},
      //   {"lng":113.22326,"lat":23.115782,"count":100},
      //   {"lng":113.219239,"lat":23.116759,"count":39},
      //   {"lng":113.217185,"lat":23.129123,"count":11},
      //   {"lng":113.217237,"lat":23.127518,"count":9},
      //   {"lng":113.217784,"lat":23.115754,"count":47},
      //   {"lng":113.220193,"lat":23.117061,"count":52},
      //   {"lng":113.222735,"lat":23.115619,"count":100},
      //   {"lng":113.218495,"lat":23.115958,"count":46},
      //   {"lng":113.216292,"lat":23.131136,"count":9},
      //   {"lng":113.219916,"lat":23.124055,"count":8},
      //   {"lng":113.22189,"lat":23.121308,"count":11},
      //   {"lng":113.213765,"lat":23.129376,"count":3},
      //   {"lng":113.218232,"lat":23.120348,"count":50},
      //   {"lng":113.217554,"lat":23.130511,"count":15},
      //   {"lng":113.218568,"lat":23.118161,"count":23},
      //   {"lng":113.213461,"lat":23.126306,"count":3},
      //   {"lng":113.22232,"lat":23.12161,"count":13},
      //   {"lng":113.2174,"lat":23.128616,"count":6},
      //   {"lng":113.224679,"lat":23.115499,"count":21},
      //   {"lng":113.22171,"lat":23.115738,"count":29},
      //   {"lng":113.217836,"lat":23.116998,"count":99},
      //   {"lng":113.220755,"lat":23.128001,"count":10},
      //   {"lng":113.214077,"lat":23.130655,"count":14},
      //   {"lng":113.226092,"lat":23.122995,"count":16},
      //   {"lng":113.21535,"lat":23.131054,"count":15},
      //   {"lng":113.213022,"lat":23.121895,"count":13},
      //   {"lng":113.215551,"lat":23.113373,"count":17},
      //   {"lng":113.221191,"lat":23.126572,"count":1},
      //   {"lng":113.219612,"lat":23.117119,"count":9},
      //   {"lng":113.218237,"lat":23.121337,"count":54},
      //   {"lng":113.223776,"lat":23.121919,"count":26},
      //   {"lng":113.217694,"lat":23.12536,"count":17},
      //   {"lng":113.215377,"lat":23.114137,"count":19},
      //   {"lng":113.217434,"lat":23.114394,"count":43},
      //   {"lng":113.22588,"lat":23.122622,"count":27},
      //   {"lng":113.218345,"lat":23.119467,"count":8},
      //   {"lng":113.226883,"lat":23.117171,"count":3},
      //   {"lng":113.223877,"lat":23.116659,"count":34},
      //   {"lng":113.215712,"lat":23.115613,"count":14},
      //   {"lng":113.219869,"lat":23.131416,"count":12},
      //   {"lng":113.216956,"lat":23.125377,"count":11},
      //   {"lng":113.22066,"lat":23.125017,"count":38},
      //   {"lng":113.216244,"lat":23.120215,"count":91},
      //   {"lng":113.21929,"lat":23.115908,"count":54},
      //   {"lng":113.222116,"lat":23.119658,"count":21},
      //   {"lng":113.2183,"lat":23.125015,"count":15},
      //   {"lng":113.221969,"lat":23.113527,"count":3},
      //   {"lng":113.222936,"lat":23.121854,"count":24},
      //   {"lng":113.21905,"lat":23.129217,"count":12},
      //   {"lng":113.224579,"lat":23.114987,"count":57},
      //   {"lng":113.22076,"lat":23.115251,"count":70},
      //   {"lng":113.225867,"lat":23.118989,"count":8}];

      // var points=this.GPSdatalist
      //
      // if(!isSupportCanvas()){
      //   alert('热力图目前只支持有canvas支持的浏览器,您所使用的浏览器不能使用热力图功能~')
      // }
      // //详细的参数,可以查看heatmap.js的文档 https://github.com/pa7/heatmap.js/blob/master/README.md
      // //参数说明如下:
      // /* visible 热力图是否显示,默认为true
      //    * opacity 热力的透明度,1-100
      //    * radius 势力图的每个点的半径大小
      //    * gradient  {JSON} 热力图的渐变区间 . gradient如下所示
      //    *	{
      //           .2:'rgb(0, 255, 255)',
      //           .5:'rgb(0, 110, 255)',
      //           .8:'rgb(100, 0, 255)'
      //       }
      //       其中 key 表示插值的位置, 0~1.
      //           value 为颜色值.
      //    */
      // var heatmapOverlay
      //  heatmapOverlay = new BMapLib.HeatmapOverlay({"radius":5,"opacity":0.5});
      // this._map.addEventListener("zoomend", function(){
      // console.log(this.getZoom())
      //   if (this.getZoom()<12) {
      //     heatmapOverlay.setOptions({"radius":1});
      //     console.log('小于：结果')
      //   }else if (this.getZoom()>12){
      //     heatmapOverlay.setOptions({"radius":5});
      //   }else if (this.getZoom()>14){
      //     heatmapOverlay.setOptions({"radius":1000});
      //   }else if (this.getZoom()>15) {
      //     heatmapOverlay.setOptions({"radius":1000});
      //   }
      //   else {
      //     heatmapOverlay.setOptions({"radius":2});
      //     console.log('中间：结果')
      //   }
      // })
      // this._map.addOverlay(heatmapOverlay);
      // heatmapOverlay.setDataSet({data:points,max:100});
      // //是否显示热力图
      // function openHeatmap(){
      //   heatmapOverlay.show();
      // }
      // function closeHeatmap(){
      //   heatmapOverlay.hide();
      // }
      // openHeatmap();
      // function setGradient(){
      //   /*格式如下所示:
      //    {
      //          0:'rgb(102, 255, 0)',
      //          .5:'rgb(255, 170, 0)',
      //          1:'rgb(255, 0, 0)'
      //    }*/
      //   var gradient = {
      //     0.1:'rgb(0,0,255)',
      //     0.2:'rgb(0,0,255)',
      //     0.3:'rgb(0,0,255)',
      //     0.4:'rgb(0,0,255)',
      //     0.5:'rgb(252,0,0)',
      //     0.6:'rgb(252,0,0)',
      //     0.7:'rgb(252,0,0)',
      //     0.8:'rgb(252,0,0)',
      //     0.9:'rgb(252,0,0)',
      //     1:'rgb(0,0,0)'
      //   };
      //   var colors = document.querySelectorAll("input[type='color']");
      //   colors = [].slice.call(colors,0);
      //   colors.forEach(function(ele){
      //     gradient[ele.getAttribute("data-key")] = ele.value;
      //   });
      //   heatmapOverlay.setOptions({"gradient":gradient});
      // }
      // setGradient();
      // //判断浏览区是否支持canvas
      // function isSupportCanvas(){
      //   var elem = document.createElement('canvas');
      //   return !!(elem.getContext && elem.getContext('2d'));
      // }
    },
    /**
     * 取rssi通信强度10及以下的
     */
    getRssiLessThanTEN () {
      if (this.datalist.length == 0) {
      // let startDatetime = new Date(1600358894000).Format('yyyy-MM-dd 00:00:00')
      // let endDatetime = new Date(1600358894000).Format('yyyy-MM-dd 23:59:59')
      // let queryParams=[]
      // queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
      // queryParams.push(genQueryParam('rssi', 'LE', 10))
        store.dispatch('WirelessDataServ_GetSignLessThanTen', {
          params: null,
          urlparams: {
          // p:p,
          // q:queryParams,
          }
        }).then(res => {
          console.log(res)
          // console.log(store.getters.get_WirelessData_GetSignLessThanTenResult)
          store.getters.get_WirelessData_GetSignLessThanTenResult.forEach((item, index) => {
            let gcpoi = GPS.gcj_encrypt(item.latitude, item.longitude)
            let bdpoi = GPS.bd_encrypt(gcpoi.lat, gcpoi.lon)
            this.datalist.push({
              'lng': bdpoi.lon, 'lat': bdpoi.lat, 'count': 56 - item.rssi
            })
          })
          // this.initGisElements()
          this.initElements(this.datalist)
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
      } else {
        this.initElements(this.datalist)
      }
    },
    /**
     * 取GPS强度10及以下的
     */
    getGPSLessThanTEN () {
      if (this.GPSdatalist.length == 0) {
      // let startDatetime = new Date(1600358894000).Format('yyyy-MM-dd 00:00:00')
      // let endDatetime = new Date(1600358894000).Format('yyyy-MM-dd 23:59:59')
      // let queryParams=[]
      // queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
      // queryParams.push(genQueryParam('gnsscount', 'LE', 10))
        store.dispatch('WirelessDataServ_GetGPSLessThanTen', {
          params: null,
          urlparams: {
          // p:p,
          // q:queryParams,
          }
        }).then(res => {
          console.log(res)
          // console.log(store.getters.get_WirelessData_GetSignLessThanTenResult)
          store.getters.get_WirelessData_GetGPSLessThanTenResult.forEach((item, index) => {
            let gcpoi = GPS.gcj_encrypt(item.latitude, item.longitude)
            let bdpoi = GPS.bd_encrypt(gcpoi.lat, gcpoi.lon)
            this.GPSdatalist.push({
              'lng': bdpoi.lon, 'lat': bdpoi.lat, 'count': 30 - item.gnsscount
            })
          })
          // this.initGisElements()
          this.initElements(this.GPSdatalist)
        }).catch(err => {
          console.log(err)
          this.$Message.error(err)
        })
      } else {
        this.initElements(this.GPSdatalist)
      }
    }

  },
  mounted () {
    this.initGisElements()
    this.getRssiLessThanTEN()
    // this.getRssiLessThanTEN()
    // let startDatetime = new Date(1600358894000).Format('yyyy-MM-dd 00:00:00')
    // let endDatetime = new Date(1600441694000).Format('yyyy-MM-dd 23:59:59')
    // let queryParams=[]
    // queryParams.push(genQueryParam('createDatetime', 'BTDT', startDatetime, endDatetime))
    // store.dispatch('WirelessDataServ_GetAll', {
    //   params: null,
    //   urlparams: {
    //     // q:queryParams,
    //   }
    // }).then(res => {
    //   console.log(res)
    //   console.log(store.getters.get_WirelessData_GetAllResult)
    //   store.getters.get_WirelessData_GetAllResult.forEach((item, index) => {
    //     // console.log(item)
    //     // console.log(item.rssi)
    //     // if (item.rssi<6){
    //
    //     let gcpoi = GPS.gcj_encrypt(item.latitude, item.longitude)
    //     let bdpoi = GPS.bd_encrypt(gcpoi.lat, gcpoi.lon)
    //     this.datalist.push({
    //       'lng': bdpoi.lon, 'lat': bdpoi.lat, 'count': 56 - item.rssi
    //     })
    //     this.GPSdatalist.push({
    //       'lng': bdpoi.lon, 'lat': bdpoi.lat, 'count': 30 - item.gnsscount
    //     })
    //     // }
    //   })
    //   // let gcpoi = GPS.gcj_encrypt(22.67262861018999,113.20182465967986)
    //   // console.log(gcpoi)
    //   // let bdpoi = GPS.bd_encrypt(22.67262861018999,113.20182465967986)
    //   // console.log(bdpoi)
    //   // this.datalist.push({
    //   //   "lng":bdpoi.lon,"lat":bdpoi.lat,"count":10
    //   // })
    //   // console.log(this.datalist)
    //   // this.initGisElements()
    //   this.initElements(this.datalist)
    // }).catch(err => {
    //   console.log(err)
    //   this.$Message.error(err)
    // })
  }
}
</script>

<style scoped>

</style>
